{
  "title": "Enervation",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "5th-level necromancy",
  "level": 5,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A tendril of inky darkness reaches out from you, touching a creature you can see within range to drain life from it. The target must make a Dexterity saving throw. On a successful save, the target takes 2d8 necrotic damage, and the spell ends. On a failed save, the target takes 4d8 necrotic damage, and until the spell ends, you can use your action on each of your turns to automatically deal 4d8 necrotic damage to the target. The spell ends if you use your action to do anything else, if the target is ever outside the spell’s range, or if the target has total cover from you. Whenever the spell deals damage to a target, you regain hit points equal to half the amount of necrotic damage the target takes.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, the damage increases by 1d8 for each slot level above 5th."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
